// @flow
import type {ListingShape} from '../components/Hit/Hit';
import type {PriceShape} from '../components/Price/Price';

export const getListingPrice = (listing: ListingShape): ?PriceShape => {
    const {averagePrice, totalPrice} = listing || {};
    return totalPrice || averagePrice || null;
};

export const listingHasPrice = (listing: ListingShape): boolean => {
    const {priceSummary} = listing || {};
    const price = getListingPrice(listing);
    return !!priceSummary || !!(price && price.currencyUnits && price.value);
};
